import billApi from '@/api/bill';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    list:null,
    bonus:null,
    listnew:null,
    historyList:null
}

export const mutationTypes = {
    getListBillStart: '[bill] get list bill start',
    getListBillSuccess: '[bill] get list bill success',
    getListBillFailure: '[bill] get list bill failure',

    getListBonusStart: '[bonus] get bonus start',
    getListBonusSuccess: '[bonus] get bonus success',
    getListBonusFailure: '[bonus] get bonus failure',

    getListBillNewStart: '[bill] get list bill new start',
    getListBillNewSuccess: '[bill] get list bill new success',
    getListBillNewFailure: '[bill] get list bill new failure',

    getDepositHistoryStart: '[history] get deposit history start',
    getDepositHistorySuccess: '[history] get deposit history success',
    getDepositHistoryFailure: '[history] get deposit history failure',
}

export const billActionTypes = {
    getListBill: '[bill] get list bill',
    getListBonus: '[bonus] get bonus',
    getListBillNew: '[bill] get list bill new',
    getDepositHistory: '[history] get deposit history' 
}

const mutations = {
    [mutationTypes.getListBillStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getListBillSuccess](state, payload) {
        state.isLoading = false
        state.list = payload
        state.validationErrors = null
    },
    [mutationTypes.getListBillFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getListBonusStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getListBonusSuccess](state, payload) {
        state.isLoading = false
        state.bonus = payload
        state.validationErrors = null
    },
    [mutationTypes.getListBonusFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getListBillNewStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.getListBillNewSuccess](state, payload) {
        state.isLoading = false
        state.listnew = payload
        state.validationErrors = null
    },
    [mutationTypes.getListBillNewFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.getDepositHistoryStart](state) {
        state.isLoading = true
        state.historyList = null
    },
    [mutationTypes.getDepositHistorySuccess](state, payload) {
        state.isLoading = false
        state.historyList = payload
        state.validationErrors = null
    },
    [mutationTypes.getDepositHistoryFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    

}

const actions = {
    [billActionTypes.getListBill](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListBillStart)
            billApi
                .getListBill(data)
                .then(response => {
                    context.commit(mutationTypes.getListBillSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListBillFailure,response)
                })
        })
    },
    [billActionTypes.getListBonus](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListBonusStart)
            billApi
                .getListBonus(data)
                .then(response => {
                    context.commit(mutationTypes.getListBonusSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListBonusFailure,response)
                })
        })
    },
    [billActionTypes.getListBillNew](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getListBillNewStart)
            billApi
                .getListBillNew(data)
                .then(response => {
                    context.commit(mutationTypes.getListBillNewSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getListBillNewFailure,response)
                })
        })
    },
    [billActionTypes.getDepositHistory](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getDepositHistoryStart)
            billApi
                .getDepositHistory(data)
                .then(response => {
                    context.commit(mutationTypes.getDepositHistorySuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getDepositHistoryFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}